// Translations
import phoneVerificationDialog from '../components/phone-verification-dialog/translations/ru'

// Translation: Model > Phone number verifier (Russian)
export default Object.freeze({
	actions: {
		verify: ''
	},
	components: { phoneVerificationDialog }
})
